import * as React from "react";
import type { SVGProps } from "react";
const SvgTruck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M1 3V2a1 1 0 0 0-1 1zm15 0h1a1 1 0 0 0-1-1zM1 16H0a1 1 0 0 0 1 1zm15-8V7a1 1 0 0 0-1 1zm4 0 .707-.707A1 1 0 0 0 20 7zm3 3h1a1 1 0 0 0-.293-.707zm0 5v1a1 1 0 0 0 1-1zM1 4h15V2H1zm14-1v13h2V3zm1 12H1v2h15zM2 16V3H0v13zm14-7h4V7h-4zm3.293-.293 3 3 1.414-1.414-3-3zM22 11v5h2v-5zm1 4h-7v2h7zm-6 1V8h-2v8zM7 18.5A1.5 1.5 0 0 1 5.5 20v2A3.5 3.5 0 0 0 9 18.5zM5.5 20A1.5 1.5 0 0 1 4 18.5H2A3.5 3.5 0 0 0 5.5 22zM4 18.5A1.5 1.5 0 0 1 5.5 17v-2A3.5 3.5 0 0 0 2 18.5zM5.5 17A1.5 1.5 0 0 1 7 18.5h2A3.5 3.5 0 0 0 5.5 15zM20 18.5a1.5 1.5 0 0 1-1.5 1.5v2a3.5 3.5 0 0 0 3.5-3.5zM18.5 20a1.5 1.5 0 0 1-1.5-1.5h-2a3.5 3.5 0 0 0 3.5 3.5zM17 18.5a1.5 1.5 0 0 1 1.5-1.5v-2a3.5 3.5 0 0 0-3.5 3.5zm1.5-1.5a1.5 1.5 0 0 1 1.5 1.5h2a3.5 3.5 0 0 0-3.5-3.5z"
    />
  </svg>
);
export default SvgTruck;
